import { createSelector } from 'reselect';
import { PlaidState } from './reducer';

const plaidState = (state): PlaidState => state.plaid;

export const selectIsPlaidInfoMessageVisible = createSelector(
  plaidState,
  state => state.isPlaidInfoMessageVisible,
);
